export default __webpack_public_path__ + "static/media/copy.d27d0b66.svg";